import { DcBaseComponent } from '@deleteagency/dc';
import constants from 'general/js/constants';
import Flickity from 'flickity';

export default class ModalCarouselComponent extends DcBaseComponent {
    static getNamespace() {
        return 'modal-carousel';
    }

    onInit() {
        // Flickity can be broken without additional delay
        // todo consider more reliable approach
        setTimeout(() => {
            this.carousel = new Flickity(this.element, {
                contain: true,
                setGallerySize: true,
                wrapAround: true,
                pageDots: true,
                arrowShape: constants.CAROUSEL_ARROW_SHAPE,
            });
        }, 100);
    }
}
